import React, { useContext, useState, useEffect } from 'react'
import './HomeNavLinks.css'
import { NavLink } from 'react-router-dom'
import { AuthContext } from '../../context/auth-context'

const HomeNavLinks = (props) => {
	const auth = useContext(AuthContext)

	// NEW: local leagueId that can come from props OR database
	const [leagueId, setLeagueId] = useState(props.leagueId || null)

	// ----------------------------
	// FETCH CURRENT TOURNAMENT
	// ----------------------------
	useEffect(() => {
		// If parent already supplied leagueId, do nothing
		if (props.leagueId) {
			setLeagueId(props.leagueId)
			return
		}

		const getCurrentLeague = async () => {
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/league/current`,
				) // <-- your backend route
				if (!response.ok) throw new Error('Failed to fetch current league')

				const data = await response.json()

				// expect: { leagueId: "684374b40c277c1376096064" }
				setLeagueId(data.leagueId)
			} catch (err) {
				console.error('Could not load current league:', err)
			}
		}

		getCurrentLeague()
	}, [props.leagueId])

	// ----------------------------

	let page
	if (auth.isLoggedIn) {
		page = '/admin/leagues/current'
	} else {
		page = '/admin/login'
	}

	console.log('leagueId: ' + leagueId)

	return (
		<ul className='home-nav-links'>
			<li>
				<NavLink to={'/schedule'}>SCHEDULE</NavLink>
			</li>

			{leagueId && (
				<li>
					<NavLink to={`/league/${leagueId}`}>STANDINGS/ROSTERS</NavLink>
				</li>
			)}

			{leagueId && (
				<li style={{ width: 'max-content' }}>
					<NavLink to={`/league/scoring/${leagueId}`}>STAT LEADERS</NavLink>
				</li>
			)}

			{!leagueId && (
				<li>
					<NavLink to={'/statsandstandings'}>STANDINGS/ROSTERS</NavLink>
				</li>
			)}

			{!leagueId && (
				<li style={{ width: 'max-content' }}>
					<NavLink to={`/scoringleaders`}>SCORING LEADERS</NavLink>
				</li>
			)}

			<li>
				<NavLink to={'/playerStats'}>PLAYER PAGES</NavLink>
			</li>

			<li>
				<NavLink to={page}>ADMIN</NavLink>
			</li>
		</ul>
	)
}

export default HomeNavLinks

/* import React, { useContext, useState, useEffect, useRef } from 'react'
import './HomeNavLinks.css'
import { NavLink, Link } from 'react-router-dom'
import { AuthContext } from '../../context/auth-context'

const HomeNavLinks = (props) => {
	console.log('inside HomeNavLinks: ' + props.leagueId)
	const auth = useContext(AuthContext)
	const propsString = props.leagueId

	let page

	if (auth.isLoggedIn) {
		page = '/admin/leagues/current'
	} else {
		page = '/admin/login'
	}
	//

	return (
		<ul className='home-nav-links'>
			<li>
				<NavLink to={'/schedule'}>SCHEDULE</NavLink>
			</li>
			{props.leagueId && (
				<li>
					<NavLink to={`/league/${propsString}`}>STANDINGS/ROSTERS</NavLink>
				</li>
			)}
			{props.leagueId && (
				<li style={{ width: 'max-content' }}>
					<NavLink to={`/league/scoring/${propsString}`}>
						SCORING LEADERS
					</NavLink>
				</li>
			)}
			{!props.leagueId && (
				<li>
					<NavLink to={'/statsandstandings'}>STANDINGS/ROSTERS</NavLink>
				</li>
			)}
			{!props.leagueId && (
				<li style={{ width: 'max-content' }}>
					<NavLink to={`/scoringleaders`}>SCORING LEADERS</NavLink>
				</li>
			)}
			<li>
				<NavLink to={'/playerStats'}>PLAYER PAGES</NavLink>
			</li>
			<li>
				<NavLink to={page}>ADMIN</NavLink>
			</li>
		</ul>
	)
}

export default HomeNavLinks */
